import * as variables from './variables.js';

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import './component/menu.service';

import Forms from './component/Forms';
Forms.init();

import Gallery from './component/Gallery';
new Gallery();
